import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { School } from '@teetsh/app/src/types/school';

export const SCHOOLS_KEY = 'schools';

interface Props {
  schoolyearId?: string;
}

function getSchools(schoolyearId: string): Promise<School[]> {
  return request(`/schoolyears/${schoolyearId}/schools`, {
    method: 'GET',
  }).then(res => res.data);
}

export default function useSchools({ schoolyearId }: Props) {
  return useQuery({
    queryKey: [SCHOOLS_KEY, schoolyearId],
    queryFn: () => getSchools(schoolyearId || ''),
    refetchOnWindowFocus: false,

    // 10 mins
    staleTime: 10 * (60 * 1000),

    // 15 mins
    gcTime: 15 * (60 * 1000),

    enabled: !!schoolyearId,
  });
}
